<template>
  <ts-card>
    <div class="form-header  ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative ">
      <h4 class="ts-text-sm">
        {{
          $t(
            'school.academic.setup.program.subject.core_subjects.new_core_subject'
          )
        }}
      </h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{
                  $t(
                    'school.academic.setup.program.subject.core_subjects.program'
                  )
                }}
              </label>
              <div>
                <select class="form-control" :class="{ 'is-invalid': errors.has('acp_id') }" v-model="model.acp_id">
                  <option value>{{ $t('select') }}</option>
                  <option v-for="(p, index) in programs" :key="index" :value="p.acp_id">{{ p.acp_name_foreign }}</option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('acp_id')">
                  {{ errors.first('acp_id') }}
                </div>
                <!-- <ts-select class="form-control" v-model="model.acp_id" :options="
                  programs.map(p => {
                    if ($i18n.locale === 'kh') {
                      return {
                        text: p.acp_name_native,
                        value: p.acp_id
                      }
                    } else {
                      return {
                        text: p.acp_name_foreign,
                        value: p.acp_id
                      }
                    }
                  })
                " :class="{ 'is-invalid': errors.has('acp_id') }" />
                <div class="invalid-feedback" v-if="errors.has('acp_id')">
                  {{ errors.first('acp_id') }}
                </div> -->
              </div>
            </div>
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required" style="margin-bottom: -5">
                {{
                  $t(
                    'school.academic.setup.program.subject.core_subjects.sub_program'
                  )
                }}
              </label>
              <div>
                <a-select v-model="model.acps_id" :class="{ 'is-invalid': errors.has('acps_id') }"
                  :options="subPrograms.filter(sp => sp.acp_id == model.acp_id).map(sp => ({ value: sp.acps_id, label: sp.acps_name_foreign }))">
                </a-select>
                <div class="invalid-feedback" v-if="errors.has('acps_id')">
                  {{ errors.first('acps_id') }}
                </div>
                <!-- <ts-select class="form-control" v-model="model.acps_id" :class="{ 'is-invalid': errors.has('acps_id') }"
                  :options="
                    subPrograms
                      .filter(sp => sp.acp_id == model.acp_id)
                      .map(sp => {
                        if ($i18n.locale === 'kh') {
                          return {
                            text: sp.acps_name_native,
                            value: sp.acps_id
                          }
                        } else {
                          return {
                            text: sp.acps_name_foreign,
                            value: sp.acps_id
                          }
                        }
                      })
                  " /> -->
              </div>
            </div>
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{
                  $t(
                    'school.academic.setup.program.subject.core_subjects.subject_(en)'
                  )
                }}
              </label>
              <div>
                <input class="form-control" v-model="model.subject_name_foreign" :class="{
                  'is-invalid': errors.has('subject_name_foreign')
                }" />
                <div class="invalid-feedback" v-if="errors.has('subject_name_foreign')">
                  {{ errors.first('subject_name_foreign') }}
                </div>
              </div>
            </div>
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{
                  $t(
                    'school.academic.setup.program.subject.core_subjects.subject_(kh)'
                  )
                }}
              </label>
              <div>
                <input class="form-control" v-model="model.subject_name_native" :class="{
                  'is-invalid': errors.has('subject_name_native')
                }" />
                <div class="invalid-feedback" v-if="errors.has('subject_name_native')">
                  {{ errors.first('subject_name_native') }}
                </div>
              </div>
            </div>
            <div class="form-group m-b-10">
              <label class="col-form-label control-label">
                {{
                  $t(
                    'school.academic.setup.program.subject.core_subjects.subject_code'
                  )
                }}
              </label>
              <div>
                <ts-input class="form-control" v-model="model.subject_code" />
              </div>
            </div>
            <div class="form-group m-b-10">
              <label class="col-form-label control-label">
                {{
                  $t(
                    'school.academic.setup.program.subject.core_subjects.order'
                  )
                }}
              </label>
              <div>
                <ts-input class="form-control" v-model="model.subject_order" />
                <small class="f-s-12 text-grey-darker" style="font-size: 10px !important">
                  {{
                    $t(
                      'school.academic.setup.program.subject.core_subjects.khmer_secondary_progam_only'
                    )
                  }}
                </small>
              </div>
            </div>
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{
                  $t(
                    'school.academic.setup.program.subject.core_subjects.display'
                  )
                }}
              </label>
              <div>
                <select class="form-control" :class="{ 'is-invalid': errors.has('display_column') }"
                  v-model="model.display_column">
                  <option value>{{ $t('select') }}</option>
                  <option value="1">ខ្មែរ</option>
                  <option value="2">English</option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('display_column')">
                  {{ errors.first('display_column') }}
                </div>
                <!-- <ts-select class="form-control" v-model="model.display_column"
                  :class="{ 'is-invalid': errors.has('display_column') }" :options="[
                    { text: 'ខ្មែរ', value: 1 },
                    { text: 'English', value: 2 }
                  ]" /> -->
              </div>
              <div>
                <ts-checkbox v-model="model.is_elective_subject_parent">
                  {{
                    $t(
                      'school.academic.setup.program.subject.core_subjects.is_elective_subject_parent'
                    )
                  }}
                </ts-checkbox>
              </div>
              <div>
                <ts-checkbox v-model="model.is_generate_total_score">
                  {{ $t('school.academic.setup.program.subject.core_subjects.is_generate_total_score') }}
                </ts-checkbox>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label">
                {{
                  $t(
                    'school.academic.setup.program.subject.core_subjects.copyFromSubject'
                  )
                }}
              </label>
              <div>
                <select class="form-control" v-model="subject_id" @change="onSubjectChange($event)">
                  <option v-for="(s, index) in subjects" :key="index" :value="s.subject_id">{{ s.subject_name_foreign }}
                    {{ s.subject_code ? ' | ' + s.subject_code : '' }}
                  </option>
                </select>
                <!-- <ts-select class="form-control" v-model="subject_id" :class="{ 'is-invalid': errors.has('subject_id') }"
                  :options="
                    subjects.map(s => ({
                      text:
                        s.subject_name_foreign +
                        (s.subject_code ? ' | ' + s.subject_code : ''),
                      value: s.subject_id
                    }))
                  " @change="onSubjectChange($event)" /> -->
              </div>
            </div>
            <assessment-components v-model="model.component_list" />
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button @click.prevent="$emit('close')" :disabled="saving">{{
              $t('cancel')
            }}</ts-button>
            <ts-button color="primary" class="ml-2" :waiting="saving" @click.prevent="submit">{{ $t('save') }}</ts-button>
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { Errors } from 'form-backend-validation'
import AssessmentComponents from './assessment-components.vue'

export default {
  name: 'subject-core-form',
  props: ['editData', 'programs', 'subPrograms', 'subjects'],
  components: {
    AssessmentComponents
  },
  data() {
    return {
      subject_id: null,
      model: {
        acp_id: this.editData ? this.editData.acp_id : '',
        acps_id: this.editData ? this.editData.acps_id : '',

        subject_name_native: this.editData
          ? this.editData.subject_name_native
          : '',
        subject_name_foreign: this.editData
          ? this.editData.subject_name_foreign
          : '',
        subject_code: this.editData ? this.editData.subject_code : '',
        subject_order: this.editData ? this.editData.subject_order : '',
        display_column: this.editData ? this.editData.display_column : '',
        component_list:
          this.editData && this.editData.component_list
            ? this.editData.component_list.map(comp => ({
              subject_comp_id: comp.subject_comp_id,
              comp_item_name: comp.comp_item_name,
              display_order: comp.display_order,
              is_appear_in_score_entry: comp
                ? comp.is_appear_in_score_entry
                  ? true
                  : false
                : true,
              is_auto_from_att: comp
                ? comp.is_auto_from_att
                  ? true
                  : false
                : true,
              component_items: comp.component_items.map(item => ({
                subject_comp_id: item.subject_comp_id,
                subject_comp_detail_id: item.subject_comp_detail_id,
                subject_comp_item_detail_name:
                  item.subject_comp_item_detail_name,
                max_score: item.max_score,
                display_order: item.display_order
              }))
            }))
            : [],
        is_elective_subject_parent: this.editData
          ? this.editData.is_elective_subject_parent
            ? true
            : false
          : false,
        is_generate_total_score: this.editData
          ? this.editData.is_generate_total_score
            ? true
            : false
          : true
      },
      errors: new Errors(),
      saving: false
    }
  },
  computed: {
    formTitle() {
      return this.editData ? 'Edit core subject' : 'New core subject'
    }
  },
  created() { },
  methods: {
    submit() {
      let response

      this.errors = new Errors()
      this.saving = true

      if (this.editData) {
        response = this.$store.dispatch('subjectCore/update', {
          subject_id: this.editData.subject_id,
          ...this.model
        })
      } else {
        response = this.$store.dispatch('subjectCore/store', this.model)
      }

      response
        .then(response => {
          this.$store.dispatch('subjectCore/fetch').then(() => {
            this.saving = false
            this.$toasted.success(response.message)
            this.$emit('close')
          })
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    onSubjectChange(event) {
      this.model.component_list = []
      let subject = this.subjects.find(e => e.subject_id == event.target.value)
      if (subject) {
        this.model.component_list =
          subject.component_list.length > 0
            ? subject.component_list.map(comp => ({
              subject_comp_id: 0,
              comp_item_name: comp.comp_item_name,
              display_order: comp.display_order,
              is_appear_in_score_entry: comp
                ? comp.is_appear_in_score_entry
                  ? true
                  : false
                : true,
                is_auto_from_att: comp
                ? comp.is_auto_from_att
                  ? true
                  : false
                : true,
              component_items: comp.component_items.map(item => ({
                subject_comp_id: 0,
                subject_comp_detail_id: 0,
                subject_comp_item_detail_name:
                  item.subject_comp_item_detail_name,
                max_score: item.max_score,
                display_order: item.display_order
              }))
            }))
            : []
      }
    }
  },
  watch: {
    'model.acp_id': function () {
      this.model.acps_id = ''
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('subjectCore/RESET_STATE')
    }
    next()
  }
}
</script>
